/* ============================================================
   kenania-cart-state.js
   يُعلّم بطاقات المنتجات الموجودة في السلة بالصنف kn-in-cart،
   فتتحوّل أيقونة "أضف إلى السلة" إلى الحالة الذهبية النشطة.

   المطابقة تتم بـ handle المنتج لأنه المعرّف الوحيد المتاح على
   البطاقة (من رابط المنتج) وفي /cart.js معاً — معرّفات المتغيّرات
   ليست مكشوفة على كل بطاقة.
   ============================================================ */
(() => {
  const IN_CART_CLASS = 'kn-in-cart';
  const CARD_SELECTOR = '.product-card';

  const handleFromCard = (card) => {
    // زر المفضّلة يحمل الـ handle صراحةً — أدقّ مصدر متاح
    const wl = card.querySelector('[data-product-handle]');
    if (wl && wl.dataset.productHandle) return wl.dataset.productHandle;
    // وإلا نستخرجه من أول رابط منتج داخل البطاقة
    const a = card.querySelector('a[href*="/products/"]');
    if (!a) return null;
    const m = a.getAttribute('href').match(/\/products\/([^/?#]+)/);
    return m ? decodeURIComponent(m[1]) : null;
  };

  const paint = (handles) => {
    document.querySelectorAll(CARD_SELECTOR).forEach((card) => {
      const h = handleFromCard(card);
      card.classList.toggle(IN_CART_CLASS, !!h && handles.has(h));
    });
  };

  /* تنسيق العملة بلا أصفار زائدة — مطابق لصيغة المتجر (فواصل عشرية
     بالفاصلة وآلاف بالنقطة) مع حذف ",00". رمز العملة يُقرأ من
     Shopify.currency الحيّ لا من نص ثابت، فأي تبديل لعملة المتجر
     (QAR → AED مثلاً) ينعكس هنا فوراً بلا تعديل كود. */
  const fmtQar = (cents) => {
    const cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'AED';
    const fixed = (Number(cents || 0) / 100).toFixed(2);
    const parts = fixed.split('.');
    const whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return cur + ' ' + (parts[1] === '00' ? whole : whole + ',' + parts[1]);
  };

  /* المجموع في درج السلة: تحديثات الثيم الجزئية (تغيير كمية مثلاً)
     لا تلمس الفوتر دائماً — نحدّثه نحن من مصدر الحقيقة /cart.js */
  const paintDrawerTotal = (cart) => {
    document.querySelectorAll('cart-drawer .totals__total-value').forEach((el) => {
      el.textContent = fmtQar(cart.total_price);
    });
  };

  /* عند أدنى كمية: أيقونة الناقص تصير سلة مهملات حمراء —
     إشارة صريحة أن الكبسة التالية تحذف الغرض من السلة. */
  const paintMinusTrash = () => {
    document.querySelectorAll('cart-drawer .cart-item quantity-input').forEach((wrap) => {
      const input = wrap.querySelector('.quantity__input');
      const minus = wrap.querySelector('.quantity__button[name="minus"]');
      if (!input || !minus) return;
      const floor = parseInt(input.getAttribute('data-min'), 10) || 1;
      const atFloor = (parseInt(input.value, 10) || 1) <= floor;
      minus.classList.toggle('kn-minus-trash', atFloor);
      const icon = minus.querySelector('i');
      if (icon) {
        icon.classList.toggle('bi-dash', !atFloor);
        icon.classList.toggle('bi-trash', atFloor);
      }
    });
  };

  let inFlight = null;
  let queued = false;
  const sync = () => {
    // طلب واحد في اللحظة؛ وأي نداء يصل أثناءه يُعاد تشغيله بعده —
    // فلا تضيع آخر حالة للسلة عند تتالي الأحداث السريع.
    if (inFlight) { queued = true; return inFlight; }
    inFlight = fetch(window.routes && window.routes.cart_url ? window.routes.cart_url + '.js' : '/cart.js', {
      headers: { Accept: 'application/json' },
    })
      .then((r) => (r.ok ? r.json() : null))
      .then((cart) => {
        if (!cart || !Array.isArray(cart.items)) return;
        paint(new Set(cart.items.map((i) => i.handle).filter(Boolean)));
        paintDrawerTotal(cart);
        paintMinusTrash();
      })
      .catch(() => {})
      .finally(() => {
        inFlight = null;
        if (queued) { queued = false; sync(); }
      });
    return inFlight;
  };

  /* ------------------------------------------------------------
     زر + في "قد يعجبك أيضاً" داخل درج السلة (kn-cart-recs في
     snippets/cart-drawer.liquid): إضافة أياكس تُبقي الزائر في
     الدرج وتعيد رسمه محدَّثاً. لا نعتمد على product-form لأن
     ملفه لا يُحمَّل خارج صفحات المنتج — capture لنسبقه حين يوجد.
     ------------------------------------------------------------ */
  const initRecsQuickAdd = () => {
    document.addEventListener('submit', (e) => {
      const form = e.target;
      if (!form.classList || !form.classList.contains('kn-cart-recs__f')) return;
      e.preventDefault();
      e.stopPropagation();

      const btn = form.querySelector('button[type="submit"]');
      const spinner = form.querySelector('.loading__spinner');
      if (btn) btn.classList.add('loading');
      if (spinner) spinner.classList.remove('hidden');

      const fd = new FormData(form);
      fd.append('sections', 'cart-drawer,cart-icon-bubble');
      fd.append('sections_url', window.location.pathname);

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' },
        body: fd,
      })
        .then((r) => r.json())
        .then((data) => {
          const sections = data && data.sections;
          if (sections && sections['cart-drawer']) {
            const doc = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
            const fresh = doc.querySelector('#CartDrawer');
            const current = document.querySelector('#CartDrawer');
            if (fresh && current) current.innerHTML = fresh.innerHTML;
          }
          if (sections && sections['cart-icon-bubble']) {
            const doc2 = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
            const wrap = doc2.querySelector('.shopify-section') || doc2.body;
            document.querySelectorAll('[id="cart-icon-bubble"]').forEach((el) => {
              el.innerHTML = wrap.innerHTML;
            });
          }
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'kn-cart-recs', cartData: data });
          }
        })
        .catch(() => {
          // فشل الشبكة: نطفئ التحميل ليعيد الزائر المحاولة بنقرة أخرى
          if (btn && document.contains(btn)) btn.classList.remove('loading');
          if (spinner && document.contains(spinner)) spinner.classList.add('hidden');
        });
    }, true);
  };

  /* صفحة السلة الكاملة /cart لا تعيد الثيم رسمها عندما يتغير
     محتوى السلة من الدرج (حذف أو إضافة فوقها) — نسحب قسمي
     main-cart-items وmain-cart-footer طازجين من السيرفر عند كل
     تغيير، فتبقى الصفحة صادقة بلا تحديث يدوي. */
  let mcTimer = null;
  let mcBusy = false;
  const refreshMainCart = () => {
    const pageContents = document.querySelector('cart-items .js-contents');
    if (!pageContents) return; /* لسنا في صفحة السلة */
    clearTimeout(mcTimer);
    mcTimer = setTimeout(() => {
      if (mcBusy) return;
      mcBusy = true;
      fetch(window.location.pathname + '?sections=main-cart-items,main-cart-footer')
        .then((r) => r.json())
        .then((sections) => {
          if (sections && sections['main-cart-items']) {
            const doc = new DOMParser().parseFromString(sections['main-cart-items'], 'text/html');
            const fresh = doc.querySelector('cart-items .js-contents');
            const freshHost = doc.querySelector('cart-items');
            const curHost = document.querySelector('cart-items');
            if (fresh) pageContents.innerHTML = fresh.innerHTML;
            /* صنف is-empty يكشف حالة السلة الفارغة المصمّمة */
            if (freshHost && curHost) curHost.className = freshHost.className;
          }
          if (sections && sections['main-cart-footer']) {
            const doc2 = new DOMParser().parseFromString(sections['main-cart-footer'], 'text/html');
            const freshFooter = doc2.getElementById('main-cart-footer');
            const curFooter = document.getElementById('main-cart-footer');
            if (freshFooter && curFooter) curFooter.innerHTML = freshFooter.innerHTML;
          }
        })
        .catch(() => {})
        .finally(() => { mcBusy = false; });
    }, 200);
  };

  /* ناقص الكمية عند 1 داخل الدرج = حذف الغرض كاملاً — بدل رسالة
     "الحد الأدنى 1" المحيّرة. نلتقط النقرة قبل معالج الثيم ونمررها
     لزر الحذف الأصلي فيتكفل بمساره المعتاد. */
  const initMinusToRemove = () => {
    document.addEventListener('click', (e) => {
      if (!e.target.closest) return;
      const minus = e.target.closest('cart-drawer .cart-item .quantity__button[name="minus"]');
      if (!minus) return;
      const wrap = minus.closest('quantity-input');
      const input = wrap && wrap.querySelector('.quantity__input');
      const floor = input ? (parseInt(input.getAttribute('data-min'), 10) || 1) : 1;
      if (!input || (parseInt(input.value, 10) || 1) > floor) return;
      e.preventDefault();
      e.stopPropagation();
      const item = minus.closest('.cart-item');
      const rm = item && item.querySelector('cart-remove-button button, cart-remove-button a');
      if (rm) rm.click();
    }, true);
  };

  /* مفوَّض واحد لأزرار المفضلة: الأزرار المحقونة بعد التحميل
     (فلترة، تحميل كسول، إعادة رسم أقسام) كانت بلا مستمع، وإعادة
     ربط wishlist.min.js تكدّس مستمعات فتعكس النقرة نفسها مرتين.
     نوقف الجميع في مرحلة الالتقاط ونتولى التبديل من مكان واحد. */
  /* احتفالية قلوب عند الإضافة للمفضلة: قلب أحمر ينبض في المنتصف
     وقلوب صغيرة تنبثق حوله وتطفو للأعلى بتمايل ثم تتلاشى (~ثانيتان).
     تُطلق فقط عند الإضافة — إزالة منتج من المفضلة لا تحتفل بشيء. */
  let wishFxBusy = false;
  const fireWishFx = () => {
    if (wishFxBusy) return;
    wishFxBusy = true;
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const fx = document.createElement('div');
    fx.className = 'kn-wishfx';
    fx.setAttribute('aria-hidden', 'true');
    fx.innerHTML =
      '<div class="kn-wishfx__center">' +
        '<div class="kn-wishfx__ring"></div>' +
        '<div class="kn-wishfx__badge"><i class="bi bi-heart-fill"></i></div>' +
        '<div class="kn-wishfx__msg">أُضيفت إلى مفضلتك</div>' +
      '</div>';
    if (!reduced) {
      /* القلوب تنطلق من كامل عرض الشاشة أسفلها وتطفو للأعلى
         بارتفاعات وأحجام وسرعات متفاوتة — كقلوب البث المباشر. */
      const HEARTS = ['❤️', '💖', '💛', '🤍', '💕', '💘'];
      const N = 30;
      for (let i = 0; i < N; i++) {
        const s = document.createElement('span');
        s.className = 'kn-wishfx__h';
        s.textContent = HEARTS[i % HEARTS.length];
        s.style.left = (2 + Math.random() * 96).toFixed(1) + '%';
        s.style.setProperty('--dx', ((Math.random() - 0.5) * 180).toFixed(0) + 'px');
        s.style.setProperty('--dy', (window.innerHeight * (0.55 + Math.random() * 0.6)).toFixed(0) + 'px');
        s.style.setProperty('--rot', ((Math.random() - 0.5) * 80).toFixed(0) + 'deg');
        s.style.setProperty('--dur', (1.4 + Math.random() * 1).toFixed(2) + 's');
        s.style.setProperty('--delay', (Math.random() * 0.5).toFixed(2) + 's');
        s.style.fontSize = (20 + Math.random() * 26).toFixed(0) + 'px';
        fx.appendChild(s);
      }
    }
    document.body.appendChild(fx);
    requestAnimationFrame(() => requestAnimationFrame(() => fx.classList.add('is-live')));
    setTimeout(() => fx.classList.add('is-out'), 2000);
    setTimeout(() => { fx.remove(); wishFxBusy = false; }, 2700);
  };

  const initWishlistDelegate = () => {
    document.addEventListener('click', (e) => {
      if (!e.target.closest) return;
      const btn = e.target.closest('[button-wishlist]');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      const handle = btn.dataset.productHandle;
      if (!handle || typeof updateWishlist !== 'function' || typeof wishlistContains !== 'function') return;
      updateWishlist(handle);
      const on = wishlistContains(handle);
      document.querySelectorAll('[button-wishlist]').forEach((b) => {
        if (b.dataset.productHandle === handle) b.classList.toggle('active', on);
      });
      if (on) fireWishFx();
    }, true);
  };

  /* بريفيو منبثق عند التمرير فوق أيقونتي السلة والمفضلة في الهيدر:
     يعرض المحتوى الفعلي (صور، أسماء، كميات، أسعار، الإجمالي) بلا نقرة.
     ديسكتوب فقط — أجهزة اللمس لا تملك hover أصلاً. بانل واحد مشترك
     يُثبَّت على body بإحداثيات ثابتة كي لا يتأثر بقصّ الهيدر اللاصق. */
  const initHoverPeek = () => {
    if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

    const panel = document.createElement('div');
    panel.className = 'kn-peek';
    panel.setAttribute('dir', 'rtl');
    panel.hidden = true;
    document.body.appendChild(panel);

    let hideTimer = null;
    let cartCache = null;
    let cartAt = 0;
    const prodCache = new Map();

    const bustCart = () => { cartCache = null; };
    document.addEventListener('cart:refresh', bustCart);
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, bustCart);
    }

    const getCart = async () => {
      if (cartCache && Date.now() - cartAt < 10000) return cartCache;
      cartCache = await fetch('/cart.js').then((r) => r.json());
      cartAt = Date.now();
      return cartCache;
    };

    const getProduct = async (handle) => {
      if (prodCache.has(handle)) return prodCache.get(handle);
      const p = await fetch('/products/' + handle + '.js')
        .then((r) => (r.ok ? r.json() : null))
        .catch(() => null);
      prodCache.set(handle, p);
      return p;
    };

    const thumb = (src) => (src ? src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=96' : '');
    const esc = (s) => String(s || '').replace(/[<>&"]/g, (c) => ({ '<': '&lt;', '>': '&gt;', '&': '&amp;', '"': '&quot;' }[c]));

    const row = (img, title, meta) =>
      '<li class="kn-peek__row">' +
        (img ? '<img src="' + img + '" alt="" loading="lazy">' : '<span class="kn-peek__noimg"><i class="bi bi-image"></i></span>') +
        '<span class="kn-peek__info"><span class="kn-peek__title">' + esc(title) + '</span>' +
        (meta ? '<span class="kn-peek__meta">' + meta + '</span>' : '') +
      '</span></li>';

    const renderCart = async () => {
      panel.innerHTML = '<div class="kn-peek__loading"><span class="loading__spinner"></span></div>';
      const c = await getCart();
      if (panel.dataset.type !== 'cart') return;
      if (!c.items.length) {
        panel.innerHTML = '<div class="kn-peek__empty"><i class="bi bi-bag"></i><span>سلّتك فارغة بعد — اختر ما يعجبك.</span></div>';
        return;
      }
      const items = c.items.slice(0, 5).map((i) =>
        row(thumb(i.image), i.product_title, '×' + i.quantity + ' · ' + fmtQar(i.final_line_price))
      ).join('');
      const more = c.items.length > 5
        ? '<div class="kn-peek__more">و' + (c.items.length - 5) + ' غيرها…</div>' : '';
      panel.innerHTML =
        '<div class="kn-peek__head"><i class="bi bi-bag-check-fill"></i><span>سلّتك</span><b>' + c.item_count + '</b></div>' +
        '<ul class="kn-peek__list">' + items + '</ul>' + more +
        '<div class="kn-peek__total"><span>الإجمالي</span><b>' + fmtQar(c.total_price) + '</b></div>' +
        '<a class="kn-peek__btn" href="/cart">عرض السلة</a>';
    };

    const renderWishlist = async (url) => {
      panel.innerHTML = '<div class="kn-peek__loading"><span class="loading__spinner"></span></div>';
      let handles = [];
      try { handles = (localStorage.getItem('shopify-wishlist') || '').split(',').filter(Boolean); } catch (e) {}
      if (panel.dataset.type !== 'wishlist') return;
      if (!handles.length) {
        panel.innerHTML = '<div class="kn-peek__empty"><i class="bi bi-heart"></i><span>ما أضفت شيئاً للمفضلة بعد.</span></div>';
        return;
      }
      const prods = (await Promise.all(handles.slice(0, 5).map(getProduct))).filter(Boolean);
      if (panel.dataset.type !== 'wishlist') return;
      const items = prods.map((p) =>
        row(thumb(p.featured_image), p.title, fmtQar(p.price))
      ).join('');
      const more = handles.length > 5
        ? '<div class="kn-peek__more">و' + (handles.length - 5) + ' غيرها…</div>' : '';
      panel.innerHTML =
        '<div class="kn-peek__head"><i class="bi bi-heart-fill"></i><span>مفضلتك</span><b>' + handles.length + '</b></div>' +
        '<ul class="kn-peek__list">' + items + '</ul>' + more +
        '<a class="kn-peek__btn" href="' + esc(url || '/pages/wishlist') + '">عرض المفضلة</a>';
    };

    const open = (type, anchor) => {
      clearTimeout(hideTimer);
      panel.dataset.type = type;
      const r = anchor.getBoundingClientRect();
      const width = 320;
      panel.style.left = Math.min(window.innerWidth - width - 12, Math.max(12, r.left + r.width / 2 - width / 2)) + 'px';
      panel.style.top = (r.bottom + 10) + 'px';
      panel.hidden = false;
      requestAnimationFrame(() => panel.classList.add('is-open'));
      if (type === 'cart') renderCart();
      else renderWishlist(anchor.getAttribute('href'));
    };

    const scheduleClose = () => {
      clearTimeout(hideTimer);
      hideTimer = setTimeout(() => {
        panel.classList.remove('is-open');
        panel.hidden = true;
      }, 260);
    };

    panel.addEventListener('mouseenter', () => clearTimeout(hideTimer));
    panel.addEventListener('mouseleave', scheduleClose);

    document.querySelectorAll('#cart-icon-bubble, a[aria-label="Wishlist"]').forEach((a) => {
      if (a.dataset.knPeek) return;
      a.dataset.knPeek = '1';
      const type = a.id === 'cart-icon-bubble' ? 'cart' : 'wishlist';
      a.addEventListener('mouseenter', () => open(type, a));
      a.addEventListener('mouseleave', scheduleClose);
    });
  };

  /* احتفالية ملء الشاشة عند إضافة منتج للسلة: شارة كيس ذهبية تنبض
     مع حلقة متوسعة وهدايا وشرارات تتطاير من المركز ثم تتلاشى.
     الالتقاط باعتراض fetch: أي POST ناجح إلى ‎/cart/add — يغطي نموذج
     المنتج، والإضافة السريعة من "قد يعجبك"، وأي مسار AJAX آخر.
     الحذف والتعديل (‎/cart/change و/cart/update) لا يفعّلانها. */
  const initAddFx = () => {
    let busy = false;
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const fire = () => {
      if (busy) return;
      busy = true;
      const fx = document.createElement('div');
      fx.className = 'kn-addfx';
      fx.setAttribute('aria-hidden', 'true');
      fx.innerHTML =
        '<div class="kn-addfx__center">' +
          '<div class="kn-addfx__ring"></div>' +
          '<div class="kn-addfx__ring kn-addfx__ring--late"></div>' +
          '<div class="kn-addfx__badge"><i class="bi bi-bag-check-fill"></i></div>' +
          '<div class="kn-addfx__msg">أُضيف إلى سلّتك</div>' +
        '</div>';
      if (!reduced) {
        const EMO = ['🎁', '✨', '🛍️', '⭐', '🎉', '💛'];
        const N = 18;
        for (let i = 0; i < N; i++) {
          const s = document.createElement('span');
          s.className = 'kn-addfx__p';
          s.textContent = EMO[i % EMO.length];
          const ang = (Math.PI * 2 * i) / N + (Math.random() - 0.5) * 0.6;
          const dist = 170 + Math.random() * (Math.min(window.innerWidth, window.innerHeight) * 0.3);
          s.style.setProperty('--dx', (Math.cos(ang) * dist).toFixed(0) + 'px');
          s.style.setProperty('--dy', (Math.sin(ang) * dist + 90).toFixed(0) + 'px');
          s.style.setProperty('--rot', (Math.random() * 540 - 270).toFixed(0) + 'deg');
          s.style.setProperty('--dur', (0.9 + Math.random() * 0.55).toFixed(2) + 's');
          s.style.fontSize = (15 + Math.random() * 15).toFixed(0) + 'px';
          fx.appendChild(s);
        }
      }
      document.body.appendChild(fx);
      requestAnimationFrame(() => requestAnimationFrame(() => fx.classList.add('is-live')));
      setTimeout(() => fx.classList.add('is-out'), 1300);
      setTimeout(() => { fx.remove(); busy = false; }, 1850);
    };

    const origFetch = window.fetch;
    window.fetch = function (input, init) {
      const url = typeof input === 'string' ? input : (input && input.url) || '';
      const method = ((init && init.method) || (input && input.method) || 'GET').toUpperCase();
      const isAdd = method === 'POST' && url.indexOf('/cart/add') !== -1;
      const p = origFetch.apply(this, arguments);
      if (isAdd) p.then((res) => { if (res && res.ok) fire(); }).catch(() => {});
      return p;
    };
  };

  const start = () => {
    sync();
    initRecsQuickAdd();
    initMinusToRemove();
    initWishlistDelegate();
    initHoverPeek();
    initAddFx();
    // حدث الثيم عند نجاح الإضافة (تنشره product-form)
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, () => { sync(); refreshMainCart(); });
    }
    // شبكة أمان: بعض المسارات (درج السلة، تغيير الكمية) لا تنشر الحدث
    document.addEventListener('cart:refresh', () => { sync(); refreshMainCart(); });
    // البطاقات المحمّلة لاحقاً (تصفّح لا نهائي، شبكة المفضّلة)
    document.addEventListener('shopify-wishlist:init-product-grid', sync);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
